import _ from "lodash"
import { PUBLISH_STATUS } from "../consts"

// test: jest src/models/__tests__/RedeemCodeBundle.model.spec.js
export default class RedeemCodeBundle {
  constructor(rawData) {
    this._rawData = rawData
  }

  get publishStatus() {
    return _.get(this._rawData, 'status') || PUBLISH_STATUS.DRAFT
  }

  get isDeletable() {
    return this.publishStatus === PUBLISH_STATUS.CLOSED || this.publishStatus === PUBLISH_STATUS.DRAFT
  }
}
